import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

export default function PaymentResult() {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const isSuccess = location.pathname.includes("success");
  const [status, setStatus] = useState(isSuccess ? "checking" : "cancel");

  useEffect(() => {
    if (!isSuccess) return;
    const params = new URLSearchParams(location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); checkAuth(); return; }
        if (data.status === "expired" || attempts > 8) { setStatus("error"); return; }
      } catch (e) { if (attempts > 8) { setStatus("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, [isSuccess, location.search, checkAuth]);

  const config = {
    checking: { icon: Loader2, spin: true, color: "text-[#5aa469]", title: "Verifica del pagamento…", text: "Attendi qualche istante." },
    paid: { icon: CheckCircle2, color: "text-[#5aa469]", title: "Pagamento riuscito!", text: "Il tuo piano è stato attivato. Grazie per aver scelto MenuOne." },
    cancel: { icon: XCircle, color: "text-amber-500", title: "Pagamento annullato", text: "Nessun addebito effettuato. Puoi riprovare quando vuoi." },
    error: { icon: XCircle, color: "text-red-500", title: "Qualcosa è andato storto", text: "Non siamo riusciti a confermare il pagamento. Contatta l'assistenza se il problema persiste." },
  }[status];
  const Icon = config.icon;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-white text-gray-900" data-testid="payment-result">
      <div className="mb-8"><Logo /></div>
      <div className="rounded-2xl mo-card p-10 max-w-md w-full">
        <Icon className={`h-14 w-14 mx-auto mb-5 ${config.color} ${config.spin ? "animate-spin" : ""}`} />
        <h1 className="font-display font-bold text-3xl mb-2">{config.title}</h1>
        <p className="text-gray-500 mb-8">{config.text}</p>
        <Button onClick={() => navigate("/dashboard/billing")} className="rounded-full bg-[#5aa469] hover:bg-[#4a8a56] text-white font-semibold w-full active:scale-95 transition-transform" data-testid="back-to-billing">Torna all'abbonamento</Button>
      </div>
    </div>
  );
}
